class Xor {
    public static encrypt(salt: number, str: string) {
        let result = '';
        for (let i=0; i<str.length; i++) {
            result += String.fromCharCode( salt ^ str.charCodeAt(i) );

        }
        return result;
    }
    public static decrypt(salt: number, hash: string) {
        let result = '';
        for (let i=0; i<hash.length; i++) {
            result += String.fromCharCode( salt ^ hash.charCodeAt(i) );
        }
        return result;
    }
}

export { Xor }